import { useState } from "react";
import { useTranslation } from "react-i18next";
import { useAppDispatch } from "@/stores";
import { tenantMemberThunks } from "./store";
import { MemberCreate } from "./types";
// components
import { Button, Form, Input, Modal } from "antd";
import { PlusCircleTwoTone } from "@ant-design/icons";

export const CreateModal = () => {
  const { t } = useTranslation();

  const dispatch = useAppDispatch();

  const [form] = Form.useForm<MemberCreate>();

  const [isOpen, setIsOpen] = useState(false);

  const handleShow = () => {
    setIsOpen(true);
    form.resetFields();
  };

  const handleConfirm = async () => {
    await form.validateFields();

    try {
      void dispatch(tenantMemberThunks.list());
    } catch (e) {
      console.log(e);
    }

    setIsOpen(false);
  };

  const handleCancel = () => {
    setIsOpen(false);
  };

  return (
    <>
      <Button type="primary" icon={<PlusCircleTwoTone />} onClick={handleShow}>
        {t("domains.Member.createMember")}
      </Button>

      <Modal
        title={t("domains.Member.createMember")}
        open={isOpen}
        footer={[
          <div className="flex jc:end gap:8" key="footer">
            <Button key="back" onClick={handleCancel}>
              {t("systems.Action.cancel")}
            </Button>
            <Button key="submit" type="primary" onClick={handleConfirm}>
              {t("systems.Action.submit")}
            </Button>
          </div>,
        ]}
        onCancel={handleCancel}
      >
        <Form className="mt:16" form={form} labelCol={{ span: 6 }}>
          <Form.Item
            label={t("domains.Member.id")}
            name="id"
            rules={[
              {
                required: true,
                message: t("systems.Error.cannotBeEmpty", {
                  field: t("domains.Member.id"),
                }),
              },
            ]}
          >
            <Input
              placeholder={t("systems.Placeholder.pleaseInput", {
                field: t("domains.Member.id"),
              })}
            />
          </Form.Item>

          <Form.Item
            label={t("domains.Member.username")}
            name="username"
            rules={[
              {
                required: true,
                message: t("systems.Error.cannotBeEmpty", {
                  field: t("domains.Member.username"),
                }),
              },
            ]}
          >
            <Input
              placeholder={t("systems.Placeholder.pleaseInput", {
                field: t("domains.Member.username"),
              })}
            />
          </Form.Item>

          <Form.Item
            label={t("domains.Member.name")}
            name="name"
            rules={[
              {
                required: true,
                message: t("systems.Error.cannotBeEmpty", {
                  field: t("domains.Member.name"),
                }),
              },
            ]}
          >
            <Input
              placeholder={t("systems.Placeholder.pleaseInput", {
                field: t("domains.Member.name"),
              })}
            />
          </Form.Item>

          <Form.Item
            label={t("domains.Member.address")}
            name="address"
            rules={[
              {
                required: true,
                message: t("systems.Error.cannotBeEmpty", {
                  field: t("domains.Member.address"),
                }),
              },
            ]}
          >
            <Input
              placeholder={t("systems.Placeholder.pleaseInput", {
                field: t("domains.Member.address"),
              })}
            />
          </Form.Item>
        </Form>
      </Modal>
    </>
  );
};
